import { z } from "zod";

const baseTrackingSchema = z.record(z.string(), z.string());

export const trackingParametersSchema = baseTrackingSchema.transform((value) =>
  Object.fromEntries(
    Object.entries(value).filter(
      ([key]) => key === "am_id" || key.startsWith("utm"),
    ),
  ),
);

export type TrackingParameters = z.infer<typeof trackingParametersSchema>;
export type OptionalTrackingParameters = TrackingParameters | null;

export const toTrackingSearchParams = (
  parameters: OptionalTrackingParameters,
): URLSearchParams => {
  const params = new URLSearchParams();

  if (!parameters) {
    return params;
  }

  for (const [key, value] of Object.entries(parameters)) {
    params.set(key, value);
  }

  return params;
};
